module.exports = __webpack_public_path__ + "static/intlepos-e706cea29a594818260295a9ac7ebe64.png";